import { IApiConfig } from "./ApiConfig";
import { FileClient, UploadFileResponse } from "./api";

/**
 * Extends the NSwag-generated FileClient with a proper multipart/form-data upload method.
 * This file is handwritten and will NOT be overwritten by `npm run nswag`.
 */
export class FileUploadClient extends FileClient {
    private readonly _baseUrl: string;
    private readonly _http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };

    constructor(
        configuration: IApiConfig,
        baseUrl?: string,
        http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> },
    ) {
        super(configuration, baseUrl, http);
        this._baseUrl = baseUrl ?? "/runtime-api";
        this._http = http ?? (window as any);
    }

    uploadFile(
        componentId: string,
        file: File,
        attributeKey?: string,
        attributeValue?: string,
        signal?: AbortSignal,
    ): Promise<UploadFileResponse> {
        const url = this._baseUrl + "/File?componentId=" + encodeURIComponent(componentId);

        const formData = new FormData();
        formData.append("file", file, file.name);
        if (attributeKey != null) {
            formData.append("attributeKey", attributeKey);
        }
        if (attributeValue != null) {
            formData.append("attributeValue", attributeValue);
        }

        const options: RequestInit = { body: formData, method: "POST", signal };

        return this.transformOptions(options).then((transformed) =>
            this._http.fetch(url, transformed),
        ).then((response: Response) => this.processUpload(response));
    }
}
